import React, { Component } from 'react';
import 'HELPDESK/Components/QueryDetails/ViewRequestModal/ExecutiveResponse/executiveresponse.css';
import executiveResponseGif from 'HELPDESK/CommonResources/images/executiveReponse.gif';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';
import { faTimes, faTrash } from '@fortawesome/free-solid-svg-icons';
import config from 'config';
import { Base64 } from 'js-base64';
import axios from 'axios';
import HelpdeskApiCall from 'HelpdeskApiCall';
export class ExecutiveResponse extends Component {
  constructor(props) {
    super(props);
    this.fileInputRef = React.createRef();
    this.state = {
      // Executive Response
      executiveResponse: {},
      executiveResponseFetching: false,
      openExecutiveResponse: false,
      serviceRequestTitle: "",
      description: "",
      purpose: "",
      subModuleId: "",
      targetElement: "",
      customizationImpact: "",
      currentRequestId: this.props.currentQueryRequestId,
      // currentRequest : this.props.currentRequest,
      currentClientResponse: this.props.currentClientResponse,
      attachments: [],
      location: '',
      attachmentFileArray: [],
      selectedAttachment: '',
      locationObjectArray: [],
      modulesFetching: false,
      moduleList: {},
      viewAttachment: false,
      attachmentPath: '',
      attachmentFile: '',
      attachmentFileExtension: '',


    }
  }
  componentDidMount() {
    this.apiCallToGetExecutiveResponse();
  }



  apiCallToGetExecutiveResponse = async () => {
    this.setState({
      executiveResponseFetching: true,
    })
    const requestData = {
      serviceRequestId: this.state.currentRequestId,
    };

    let jsonResponse = await HelpdeskApiCall.makeApiCall(
      'pmTool_getExecutiveClientServiceRequestResponseDetails',
      requestData,
      '/api/projectManagement/Queries/pmTool_userServiceRequestReceivedData.php'
    );

    if (jsonResponse.expired) {
      setTimeout(() => {
        this.apiCallToGetExecutiveResponse();
      }, 1000);
    } else {
      if (jsonResponse.success) {

        if (jsonResponse.APIResult.status === 'success') {
          let apiResult = jsonResponse.APIResult.data;

          this.setState({ executiveResponse: apiResult, executiveResponseFetching: false });



        } else {
          // toast.error(jsonResponse.APIResult.message);
          this.setState({ executiveResponseFetching: false, executiveResponse: {} });
        }

        //    this.setState()


      } else {
        console.error("Something went wrong while fetching the data.");
        toast.error(jsonResponse.message)
        this.setState({ executiveResponseFetching: false, executiveResponse: {} });
      }
    }
  }
  // pmTool_addExecutiveClientServiceRequestResponse()



  returnViewAttachment = () => {
    let imageExtensions = ['png', 'jpg', 'jpeg', 'svg'];
    return (
      <div className={this.state.viewAttachment ? "modal fade show" : "modal fade"} id="modalContainer">

        <div className="modal-dialog modal-dialog-centered modal-xl viewAttachmentDialog">
          <div className="modal-content viewAttachmentContent">
            <div className="modal-header">
              <div className="icon-container">
                <FontAwesomeIcon icon={['fas', 'paperclip']} size="lg" color='#0465AC' style={{ fontSize: 20 }} />
              </div>
              <h3 style={{ textTransform: "capitalize", fontSize: 20 }}>Attachment</h3>
              <FontAwesomeIcon
                icon={['fas', 'times']}
                style={{ cursor: 'pointer' }}
                size="lg"
                color="#000000"
                onClick={() => this.setState({ viewAttachment: false })} // Close the modal
              />
            </div>
            <div className="modal-body viewAttachment-body">
              {
                imageExtensions.includes(this.state.attachmentFileExtension) ?
                  <div>
                    <img src={this.state.attachmentPath + '/' + this.state.attachmentFile} alt='attachmentimg' width='100%' height='100%' />
                  </div>
                  :
                  <iframe src={this.state.attachmentPath + '/' + this.state.attachmentFile} alt="attachment" width='100%' height='100%' />
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
  handleAttachmentClick = (attachment, filePath) => {


    this.setState({
      viewAttachment: true,
      attachmentPath: filePath,
      attachmentFile: attachment?.fileName,
      attachmentFileExtension: attachment?.fileName.substring(attachment?.fileName.lastIndexOf('.') + 1)
    })

  };

  render() {
    return (
      <div>
        {Object.keys(this.state.executiveResponse).length > 0 ? (

          // Map it 

          Object.values(this.state.executiveResponse).length > 0 && Object.values(this.state.executiveResponse).slice(0, 1).map(executiveResponse => (

            <div className='ClientResponseContainer'>

              <div className='client-response-body'>
                <div className="client-description">
                  <p className='vm_custom_body10' style={{ color: '#808080' }}>Executive Service Request Title</p>
                  <p className='vm_custom_body10 text-break' style={{ color: '#1E1E1E' }}>{executiveResponse.querySubject}</p>
                </div>
                <div className="client-description">
                  <p className='vm_custom_body10' style={{ color: '#808080' }}>Product Query Type</p>
                  <p className='vm_custom_body10 text-break' style={{ color: '#1E1E1E' }}>{executiveResponse.queryType ? executiveResponse.queryType.charAt(0).toUpperCase() + executiveResponse.queryType.slice(1) : ''}</p>
                </div>

                <div className="client-description">
                  <p className='vm_custom_body10' style={{ color: '#808080' }}>Executive Description</p>
                  <p className='vm_custom_body10 text-break' style={{ color: '#1E1E1E' }}>{executiveResponse.queryDescription}</p>
                </div>
                <div className="client-description">
                  <p className='vm_custom_body10' style={{ color: '#808080' }}>Query Occurred In</p>
                  <p className='vm_custom_body10' style={{ color: '#1E1E1E' }}>{executiveResponse.queryOccurredIn
                  }</p>
                </div>
                <div className="client-description">
                  <p className='vm_custom_body10' style={{ color: '#808080' }}>Executive Module Name </p>
                  <p className='vm_custom_body10' style={{ color: '#1E1E1E' }}>{executiveResponse.moduleName
                  }</p>
                </div>
                <div className="client-description">
                  <p className='vm_custom_body10' style={{ color: '#808080' }}> Executive Product Sub Module</p>
                  <p className='vm_custom_body10' style={{ color: '#1E1E1E' }}>{executiveResponse.subModuleName}</p>
                </div>
                {
                  executiveResponse?.addedByName &&
                  <div className='client-description'>
                    <p className='vm_custom_body10' style={{ color: '#808080' }}>Executive Name</p>
                    <p className='vm_custom_body10' style={{ color: '#1E1E1E' }}>{executiveResponse?.addedByName}</p>
                  </div>
                }
                {executiveResponse?.accountType && executiveResponse?.accountType.trim().length !== 0 &&
                  <div className='client-description'>
                    <p className='vm_custom_body10' style={{ color: '#808080' }}>Account Type</p>
                    <p className='vm_custom_body10' style={{ color: '#1E1E1E' }}>{executiveResponse?.accountType}</p>
                  </div>
                }

                {(executiveResponse?.targetElements?.length > 0 && executiveResponse?.targetElements[0] !== "") &&
                  <div className="client-description">
                    <p className='vm_custom_body5' style={{ color: '#000000' }}>Target Element </p>

                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      {
                        executiveResponse?.targetElements?.map((element, index) => {

                          return (
                            <p className='vm_custom_body5' style={{ display: 'flex', width: 'auto', borderRadius: '50px', padding: '4px 10px', justifyContent: 'center', alignItems: 'center', cursor: 'pointer', backgroundColor: '#F1F1F1' }} >
                              {element}
                            </p>

                          );
                        })
                      }
                    </div>
                  </div>
                }
                {
                  executiveResponse?.attachments && Object.values(executiveResponse.attachments)?.length > 0 &&

                  <div>
                    <p className='vm_custom_body10' style={{ color: '#808080' }}>Attachments</p>
                    <div className="client-attachments">

                      <div style={{ display: "flex", gap: "10px", flexDirection: 'column' }}>
                        {
                          Object.values(executiveResponse.attachments)?.map((attachment, index) => {

                            return (
                              <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                                <p className='vm_custom_body8' style={{ display: 'flex', width: 'auto', borderRadius: '50px', padding: '4px 10px', justifyContent: 'center', alignItems: 'center', cursor: 'pointer', backgroundColor: '#F1F1F1' }} onClick={() => this.handleAttachmentClick(attachment, executiveResponse.attachmentPath)}>
                                  {attachment?.fileName}
                                </p>
                                <span className='vm_custom_body10' style={{ color: '#808080' }}>Location :  <span className='vm_custom_body8' style={{ color: '#1E1E1E' }} > {attachment?.errorLocation}</span></span>
                              </div>

                            );
                          })
                        }
                      </div>
                    </div>
                  </div>
                }


                {/* Render the modal conditionally */}
                {this.state.viewAttachment && this.returnViewAttachment()}
              </div>
            </div>
          )
          )

        ) : (
          <div style={{ display: 'flex', justifyContent: 'center', gap: '5px', flexDirection: 'column' }}>
            <p className='vm_custom_body10' style={{ color: '#808080' }}>Our Executive Team will review your query shortly and reach out to you soon.</p>
            {/* <img src={executiveResponseGif} alt="executiveResponseGif" />
            <button className='executive-custom-button executive-assign-btn' onClick={() => this.setState({ openExecutiveResponse: true })}>Add Response</button> */}

          </div>
        )
        }
        {/* {this.state.openExecutiveResponse && this.returnAddExecutiveModal()} */}
        {/* This is client side request form */}
        {/* {this.state.openExecutiveResponse && <ClientRequestForm openExecutiveResponse={this.state.openExecutiveResponse}/>} */}
      </div>
    )
  }
}

export default ExecutiveResponse
